import React from "react";
import { Row, Col } from "react-bootstrap";

interface ContactUsProps {
  title: string;
  buttons: React.ReactNode;
  children: React.ReactNode;
  id?: string;
  className?: string;
  titleClassName?: string;
}

const ContactUs: React.FC<ContactUsProps> = ({
  title,
  buttons,
  children,
  id,
  className,
  titleClassName,
}: ContactUsProps) => {
  return (
    <Row id={id} className={`contact-us ${className || ""}`}>
      <Col xl={"auto"}>
        <div className={`d-flex flex-column justify-content-start align-items-start ${titleClassName || ""} pb-3`}>
          <h2>{title}</h2>
          {buttons}
        </div>
      </Col>
      <Col>
        {children}
      </Col>
    </Row>
  );
};

export default ContactUs;